import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateSearchVisible, saveSearchSettings } from '../../../actions/Settings';
import { onboardingSearchActivate } from '../../../slices/OnboardingSlice';
import { loadWizardState } from '../../wizard/wizardSlice';
import { deriveCloudSetupProgress } from './cloudHomeProgress';

const WIZARD_TYPE = 'integration-wizard-v2';

/** Cloud-only Home projection over legacy settings and wizard state. */
export function useCloudHomeData() {
  const dispatch = useDispatch();
  const shopId = useSelector(state => state.app?.currentShop);
  const queryPopularState = useSelector(state => state.analytics.search.queryPopular);
  const popularByViewState = useSelector(state => state.analytics.products.popularByView);
  const settings = useSelector(state => state.settings || {});
  const wizard = useSelector(state => state.integrationWizard?.wizards?.[WIZARD_TYPE]);

  useEffect(() => {
    if (shopId) dispatch(loadWizardState(shopId, WIZARD_TYPE));
  }, [dispatch, shopId]);

  const searchVisible = settings.searchVisible?.value === true;
  const searchEnabled = settings.searchEnabled === true;
  const onboarding = settings.search?.onboarding || {};
  const setupProgress = deriveCloudSetupProgress({
    searchEnabled,
    searchVisible,
    onboarding,
    wizardStatus: wizard?.state?.status,
  });
  const queryPopular = queryPopularState.shopId === shopId
    ? queryPopularState
    : { isFetching: true, isFetched: false, data: [], curve: null, queries: null };
  const popularByView = popularByViewState.shopId === shopId
    ? popularByViewState
    : { isFetching: true, isFetched: false, data: [] };
  const isServiceActive = searchVisible || setupProgress.activated;

  return {
    shopId,
    isLoading: !shopId
      || settings.isFetched !== true
      || settings.shopId !== shopId
      || !wizard
      || wizard.loading === true,
    queryPopular,
    popularByView,
    isServiceActive,
    isServiceUpdating: settings.isUpdatingSearch || settings.isFetched !== true,
    wasInitiallyActive: isServiceActive,
    setupProgress,
    toggleService: (status) => {
      if (status) {
        dispatch(onboardingSearchActivate());
      } else {
        dispatch(updateSearchVisible(false));
        dispatch(saveSearchSettings(shopId));
      }
    },
  };
}
